import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgEmptyJournal({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={180}
      height={116}
      viewBox="0 0 180 116"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <g transform="translate(32.236 3.5)">
          <ellipse fill="#DCF2EB" cx={61} cy={58} rx={54} ry={53.5} />
          <g stroke="#000">
            <ellipse cx={54} cy={53.5} rx={53.5} ry={53} />
            <path
              d="M67.497 17.292c-19.98-7.273-41.997 2.82-49.175 22.54-7.178 19.721 3.2 41.604 23.181 48.876 19.98 7.273 41.997-2.82 49.175-22.54a37.489 37.489 0 002.274-12.94 37.788 37.788 0 00-1.91-11.747M85.123 32.693a37.339 37.339 0 00-2.923-3.807 37.766 37.766 0 00-4.654-4.477"
              strokeLinecap="round"
            />
          </g>
        </g>
        <g fill="#DCF2EB">
          <path d="M172.737 47.736a7.015 7.015 0 016.729 7.009v54.25a6.238 6.238 0 01-6.463 6.235 6.756 6.756 0 01-6.513-6.699l-.43-54.335a6.415 6.415 0 016.677-6.46z" />
          <path d="M176.356 10.257c2.347 6.216 3.008 17.659 1.982 34.33a4 4 0 01-5.624 3.406c-.473-.211-.944-.47-1.412-.778-3.317-2.18-4.923 1.664-6.157-5.442-1.235-7.106 1.249-17.814 1.724-20.07 1.592-7.556 5.695-18.596 6.67-18.324.736.205 2.113 5.015 2.817 6.878z" />
        </g>
        <g stroke="#000">
          <path
            d="M164.15 45.567a5.897 5.897 0 00-4.158 1.765 5.897 5.897 0 00-1.7 4.196l.43 54.335a6.145 6.145 0 001.817 4.33c1.113 1.108 2.661 1.813 4.429 1.876a5.72 5.72 0 004.049-1.68 5.72 5.72 0 001.68-4.058v-54.25c0-1.761-.7-3.364-1.879-4.538-1.164-1.16-2.791-1.9-4.669-1.976z"
            fill="#D8D8D8"
          />
          <path d="M165.196 1.377c-.194.264-.423.67-.68 1.19-.566 1.147-1.252 2.822-1.956 4.755-1.316 3.616-2.693 8.135-3.47 11.82l-.105.493c-.647 2.999-2.766 12.77-1.616 19.389.333 1.914.676 2.997 1.096 3.602.452.65 1 .61 1.642.622.879.016 1.922.045 3.201.885.445.292.892.539 1.342.74a3.5 3.5 0 004.92-2.98l.047-.766c.952-16.152.3-27.275-1.997-33.357a60.296 60.296 0 01-.662-1.915c-.547-1.635-1.137-3.998-1.762-4.478z" />
        </g>
        <g>
          <g fill="#DCF2EB">
            <path d="M22.197 4.201L22 36.68a6.514 6.514 0 01-7.018 6.558l-.66-.05a7 7 0 01-6.458-7l.09-32.09 14.243.104z" />
            <path d="M15.338 42.739a7.211 7.211 0 016.629 7.14l.376 58.125a6.055 6.055 0 01-6.544 6.074 7.211 7.211 0 01-6.628-7.14l-.376-58.125a6.055 6.055 0 016.543-6.074z" />
          </g>
          <g stroke="#000">
            <path
              d="M14.634 3.5v33a7 7 0 01-14 0v-33h0"
              strokeLinecap="round"
            />
            <path
              d="M7.598 44.017a6.23 6.23 0 00-4.419 1.83 6.23 6.23 0 00-1.83 4.42v54.5c0 1.725.699 3.288 1.83 4.419a6.23 6.23 0 004.42 1.83 6.23 6.23 0 004.419-1.83 6.23 6.23 0 001.83-4.42v-54.5a6.23 6.23 0 00-1.83-4.419 6.23 6.23 0 00-4.42-1.83z"
              fill="#D8D8D8"
            />
            <path d="M.75 27.962c-.024 1.852-.017 4.74.018 8.701a6.819 6.819 0 002.163 4.763 6.819 6.819 0 004.9 1.84 7.012 7.012 0 004.894-2.214 7.012 7.012 0 001.903-5.022l-.218-7.43a5.57 5.57 0 01-.324.483c-.526.695-1.05.935-1.52.902-.728-.051-1.35-.412-1.867-1.079-.28-.363-.53-.824-.75-1.375a6.497 6.497 0 01-.787 1.178c-.547.63-1.122.919-1.696.937-.595.018-1.18-.275-1.717-.99-.252-.336-.496-.772-.73-1.309-.277.652-.57 1.158-.871 1.521-.286.345-.586.572-.89.699a1.598 1.598 0 01-1.07.062c-.484-.134-.901-.561-1.215-1.17a5.512 5.512 0 01-.223-.497z" />
            <path strokeLinecap="round" d="M10.048 3.517v24.5M5.049 3.628v24" />
          </g>
        </g>
      </g>
    </svg>
  );
}
export default SvgEmptyJournal;
